import { createMakeRequest as _createMakeRequest, IMakeRequest } from '../app/helpers/network_helper';
import { normalizeHost } from '@cian/utils/lib/shared/normalize_host';
import { createClient } from '@cian/network-framework';
import { init as initLogger } from '@cian/logger/browser';
import { init as initConfig, setup as setupConfig } from '@cian/config/browser';

export const client = createClient({
  timeout: 30000,
  circuitBreaker: {
    failureTreshold: 0.5,
    samplingDuration: 20000,
    minimumSamples: 20,
    openDuration: 20000,
  },
  telemetry: {
    clientName: 'frontend_mainpage',
    serverName: 'undefined',
    normalizeHost,
    increment: (name: string) => null,
    timer: (name: string, timeDelta: number) => null,
  },
});

export function createMakeRequest(baseHost: string): IMakeRequest {
  setupConfig({
    settingsKey: 'frontend-mainpage',
  });

  initConfig();

  const logger = initLogger();

  return _createMakeRequest(
    client,
    baseHost || window.location.host,
    window.location.protocol === 'http:' ? 'http' : 'https',
    logger,
  );
}
